import analytics from '@/utils/mixins/analytics';
import customizing from '@/utils/mixins/customizing';
import { shared } from '@/utils/shared';
import Vue from 'vue';
import '@/utils/plugins/qa';
import '@/utils/filters';

import '@/scss/blocks/main.scss';
import audit from '@/utils/mixins/audit';

export default {
    mixins: [analytics, customizing, audit],
    data () {
        return {
            shared,
        };
    },
    created () {
        Object.defineProperty(window, '__odrDebugEmail', {
            set: (value) => {
                this.$store.commit('local/SET', { key: 'debugEmail', value });
            },
            get: () => {
                return this.$store.state.local.debugEmail;
            },
        });

        if (!Object.prototype.hasOwnProperty.call(window, '__odrDebugIvrServer')) {
            Object.defineProperty(window, '__odrDebugIvrServer', {
                set: (value) => {
                    this.$store.commit('local/SET', { key: 'debugIvrServer', value });
                },
                get: () => {
                    return this.$store.state.local.debugIvrServer;
                },
            });
        }

        if (!Object.prototype.hasOwnProperty.call(window, '__odrKangaroo')) {
            Object.defineProperty(window, '__odrKangaroo', {
                set: (value) => {
                    this.$store.commit('local/SET_INDEXLESS', { key: 'kangaroo', value });
                },
                get: () => {
                    return this.$store.state.local.kangaroo;
                },
            });
        }
        if (!Object.prototype.hasOwnProperty.call(window, '__odrShowBlockIds')) {
            Object.defineProperty(window, '__odrShowBlockIds', {
                set: (value) => {
                    this.$store.commit('local/SET_INDEXLESS', { key: 'showBlockIds', value });
                },
                get: () => {
                    return this.$store.state.local.showBlockIds;
                },
            });
        }

        if (this.$root.appConfig.reportErrors) {
            let sendError = (errorMsg) => {
                let xhr = new XMLHttpRequest();
                xhr.open('POST', `${this.$root.appConfig.apiUrl}/error-report`);
                xhr.send(JSON.stringify({
                    error: errorMsg,
                    userAgent: navigator.userAgent,
                }));
            };

            Vue.config.errorHandler = (error, vm, info) => {
                sendError({
                    vueError: error.toString(),
                    info: info,
                    trace: error.stack,
                }, this.$root.appConfig, this.$store.getters['flow/lastStep']);
                console.error(error);
            };

            Vue.config.warnHandler = (msg, vm, trace) => {
                sendError({
                    vueWarn: msg,
                    trace,
                }, this.$root.appConfig, this.$store.getters['flow/lastStep']);
                console.error(('[Vue warn]: ' + msg + trace));
            };

            if (window.__odrErrorsCapturing === false) {
                window.__odrErrorsCapturing = true;
                let oldOnError = window.onerror;
                window.onerror = (errorMsg, url) => {
                    if (oldOnError) { oldOnError(errorMsg, url); }

                    if (url.indexOf(this.$root.appConfig.staticUrl) === 0) {
                        sendError({
                            pageError: errorMsg,
                        }, this.$root.appConfig, this.$store.getters['flow/lastStep']);
                    }
                    return false;
                };
            }
        }
    },
};
